export const changePassword = {
  title: {
    normal: 'Reset your password',
  },
};
